import * as z from 'zod'

import { PET_CONSTANTS } from '@flows/configs/petHealth/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.too_big:
      return {
        message: t('sharedFlows_petHealth:steps.pet_age.error.tooOld', {
          max: issue.maximum,
          maxYoungerThan: Number(issue.maximum) + 1,
        }),
      }

    default:
      return { message: ctx.defaultError }
  }
}

const pet_age = (params: StepConfigParams) =>
  ({
    errorMap: getErrorMap(),
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_age_at_contract_start')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.pet_age_at_contract_start,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_age.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'dropDown',
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_age.label',
        },
        useFilterInput: false,
        styleType: 'outlined',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('pet_age_at_contract_start'),
        options: PET_CONSTANTS.petAgeOptions.map((option) => {
          return {
            value: option,
            label: {
              type: 'translatableText',
              translationKey:
                option === 0
                  ? 'sharedFlows_petHealth:steps.pet_age.ages_less_than_one'
                  : 'sharedFlows_petHealth:steps.pet_age.ages',
              values: {
                age: {
                  type: 'staticValue',
                  value: String(option),
                },
              },
            },
          }
        }),
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_age.infoBox.title',
            },
            isSmall: true,
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_age.infoBox.text.info',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_age.infoBox.text.example',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('pet_type'),
      valueToStepName: {
        cat: 'living_environment',
        dog: 'pet_quote',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pet_age
